export default function() {
  return {
    locations: [],
  };
}
